import Register from '../../../utils/Register';
import {Modal as BootstrapModal} from 'bootstrap-show-modal/src/ShowModal';

export default class ProductVideo {

	constructor (container) {
		const _this = this;

		container.querySelectorAll('.product-video-js').forEach((el) => {
			el.addEventListener('click', function(e) {
				e.preventDefault();

				const mode = this.dataset.mode;
				const videoId = this.dataset.videoId;

				if (mode === 'modal') {
					_this.openModal(videoId);
				} else if (mode === 'content') {
					_this.openContent(this, videoId);
				}
			});
		});
	}

	openModal(videoId) {
		bootstrap.showModal({
			title: 'Video',
			body: '<div class="ratio ratio-16x9">' + this.getIframe(videoId) + '</div>',
			modalDialogClass: 'modal-xl modal-dialog-centered'
		});
	}

	openContent(el, videoId) {
		el.innerHTML = this.getIframe(videoId);
	}

	getIframe(videoId) {
		return '<iframe src="' + this.getVideoUrl(videoId) + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen />';
	}

	getVideoUrl(videoId) {
		return 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&rel=0&enablejsapi=1';
	}

	static init ($container) {
		if ($container[0].querySelectorAll('.product-video-js').length > 0) {
			new ProductVideo($container[0]);
		}
	}

}

(new Register()).registerCallback(ProductVideo.init, 'ProductVideo.init');